/** Contato comercial Hbarber — Halef Barber */
export const WHATSAPP_E164 = '5564992609958';
export const WHATSAPP_DISPLAY = 'Halef Barber';
export const WHATSAPP_PHONE_LABEL = '(64) 99260-9958';

export function whatsappUrl(message: string) {
  return `https://wa.me/${WHATSAPP_E164}?text=${encodeURIComponent(message)}`;
}

export const WA_MSG = {
  starter:
    'Olá Halef! Quero o plano Starter do Hbarber (R$ 97/mês) e saber como começar.',
  pro: 'Olá Halef! Quero o plano Pro do Hbarber (R$ 247/mês) e falar sobre a contratação.',
  free: 'Olá Halef! Quero conhecer o plano Free do Hbarber e começar sem compromisso.',
  general: 'Olá Halef! Vim pelo site do Hbarber e quero saber mais sobre o sistema.',
} as const;
